import React from 'react';
import { getTableRowModeBoolean } from 'shared/Table/Actions/utilities';
import { useTableActiveRowContext } from 'shared/Table/TableActiveRowContext';
import { IActiveNumbersItem } from '@EngagementsActiveNumbers/activeNumbers.model';
import EscalationSupportModalForm from 'pages/WirelineEngagements/shared/EscalationSupportModalForm';
import { escalationTypeOptions } from 'pages/WirelineEngagements/shared/EscalationSupportModalForm/constants';

const EscalationSupportModal = () => {
  const {
    activeRow,
    activeRowId,
    activeRowMode,
    cleanActiveRow,
  } = useTableActiveRowContext<IActiveNumbersItem>();

  const { isEscalationSupportMode } = getTableRowModeBoolean(activeRowMode);
  const escalationSupportRow = isEscalationSupportMode ? activeRow : undefined;
  const escalationSupportRowId = isEscalationSupportMode ? activeRowId : undefined;

  return (
    <EscalationSupportModalForm
      cleanEscalationSupportRow={cleanActiveRow}
      escalationSupportRow={escalationSupportRow}
      escalationTypeOptions={escalationTypeOptions}
      escalationSupportRowId={escalationSupportRowId}
    />
  );
};

export default EscalationSupportModal;
